// ForecastManagerView.jsx
//
// Parent view for the collection forecasting system. Mirrors the structure
// of PowerBIManagerView: sticky header with sub-tabs, scrollable content
// below. Each sub-tab is its own self-contained component.
//
// Tab order (revised):
//   0. Forecast       - the main user view, model + time-range driven
//   1. Compare        - side-by-side multi-model comparison
//   2. Models         - manage model definitions (CRUD, channels inside)
//   3. Baseline Data  - per-model, per-channel daily volumes (editable)
//   4. Personas       - manage behavioral personas (CRUD, per model)
//   5. Calendar       - manage holidays + regenerate calendar
//
// Default tab is Forecast (subTab=0). Tab-specific edit/add actions
// live INSIDE each tab's own header strip, not at this level.

import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";

import ForecastView      from "./ForecastView";
import CompareView       from "./CompareView";
import ModelsListView    from "./Modelslistview";
import BaselineDataView  from "./BaselineDataView";
import PersonasView      from "./PersonasView";
import CalendarView      from "./CalendarView";

const SUB_TABS = [
  "Forecast",
  "Compare",
  "Models",
  "Baseline Data",
  "Personas",
  "Calendar",
];

const BLUE = "#378ADD";

export default function ForecastManagerView() {
  const [subTab, setSubTab] = useState(0);

  return (
    <Box sx={{
      width: "100%",
      height: "calc(100vh - 120px)",
      display: "flex",
      flexDirection: "column",
    }}>

      {/* ── Sticky header ── */}
      <Box sx={{
        position: "sticky", top: 0, zIndex: 10,
        backgroundColor: "background.paper",
        borderBottom: "0.5px solid", borderColor: "divider",
        display: "flex", alignItems: "center",
        px: 2, gap: 2,
        minHeight: 48,
      }}>
        <Tabs
          value={subTab}
          onChange={(_, v) => setSubTab(v)}
          sx={{
            flexGrow: 1,
            minHeight: 48,
            "& .MuiTabs-indicator": {
              height: 2,
              borderRadius: "2px 2px 0 0",
              backgroundColor: BLUE,
            },
            "& .MuiTab-root": {
              minHeight: 48,
              fontSize: 13,
              fontWeight: 400,
              textTransform: "none",
              color: "text.secondary",
              px: 1.5,
              "&.Mui-selected": {
                color: BLUE,
                fontWeight: 500,
              },
            },
          }}
        >
          {SUB_TABS.map(label => (
            <Tab key={label} label={label} disableRipple />
          ))}
        </Tabs>
      </Box>

      {/* ── Scrollable content ── */}
      <Box sx={{ flex: 1, overflow: "auto" }}>
        {subTab === 0 && <ForecastView />}
        {subTab === 1 && <CompareView />}
        {subTab === 2 && <ModelsListView />}
        {subTab === 3 && <BaselineDataView />}
        {subTab === 4 && <PersonasView />}
        {subTab === 5 && <CalendarView />}
      </Box>
    </Box>
  );
}